module.exports = __webpack_public_path__ + "img/ma260.26cc0417.png";